<template>
  <div>
    <button
      :class="['center white block col-12 btn-cta', padding, color, border, {'disabled': disabled, 'pointer': !disabled, 'caps': textCaps, 'full-height': fullHeight}]"
      @click="action()"
    >
      <span :class="['btn-cta-text', icon, textColor, textSize, { 'bold': textBold }]">
        {{ text }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: Function,
      default: () => {}
    },
    color: {
      type: String,
      default: 'red-bg'
    },
    padding: {
      type: String,
      default: 'px2'
    },
    textColor: {
      type: String,
      default: ''
    },
    border: {
      type: String,
      default: 'border-none'
    },
    textSize: {
      type: String,
      default: ''
    },
    textBold: {
      type: Boolean,
      default: true
    },
    textCaps: {
      type: Boolean,
      default: true
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
  .btn-cta {
    height: 50px;
  }

  .btn-cta-text {
    font-size: 0.9375rem;
  }
</style>
